import repository from "@/api/modules/Sales/Items";

export default {
  getAllItems({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .getallitems(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("ALL_ITEMS", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getItemCategories({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.item_categories.length > 0) {
        resolve(state.item_categories);
        return;
      }
      repository
        .getitemcategories()
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("ITEM_CATEGORIES", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getItems({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .getitems(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("ITEMS", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getItemTypes({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.item_types.length > 0) {
        resolve(state.item_types);
        return;
      }
      repository
        .getitemtypes()
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("ITEM_TYPES", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getItemUom({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.item_uom.length > 0) {
        resolve(state.item_uom);
        return;
      }
      repository
        .getitemuom()
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("ITEM_UOM", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getItemBrand({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.item_brand.length > 0) {
        resolve(state.item_brand);
        return;
      }
      repository
        .getitembrand()
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("ITEM_BRAND", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getItemSize({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.item_size.length > 0) {
        resolve(state.item_size);
        return;
      }
      repository
        .getitemsize()
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("ITEM_SIZE", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllBundles({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .getallbundles(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("ALL_BUNDLES", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getItemEditInfo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .getitemeditinfo(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("ITEM_EDIT_INFO", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  storeItem({ commit }, payload, config) {
    return new Promise((resolve, reject) => {
      repository
        .storeitem(payload, config)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("STORE_ITEM", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  storeImportItem({ commit }, payload, config) {
    return new Promise((resolve, reject) => {
      repository
        .storeimportitem(payload, config)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("STORE_IMPORT_ITEM", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  storeImportImage({ commit }, payload, config) {
    return new Promise((resolve, reject) => {
      repository
        .storeimportimage(payload, config)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("STORE_IMPORT_IMAGE", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  storeImportImageExcel({ commit }, payload, config) {
    return new Promise((resolve, reject) => {
      repository
        .storeimportimageexcel(payload, config)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("STORE_IMPORT_IMAGE", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateImportItem({ commit }, payload, config) {
    return new Promise((resolve, reject) => {
      repository
        .updateImportItem(payload, config)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("UPDATE_IMPORT_ITEM", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  showItem({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .showitem(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("SHOW_ITEM", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateSelectedItem({ commit }, payload, config) {
    return new Promise((resolve, reject) => {
      repository
        .updateselecteditem(payload, config)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("UPDATE_SELECTED_ITEM", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  destroyItem({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .destroyitem(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("DESTROY_ITEM", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  storeItemBundle({ commit }, payload, config) {
    return new Promise((resolve, reject) => {
      repository
        .storeitembundle(payload, config)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("STORE_ITEM_BUNDLE", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getItemBundle({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .getitembundle(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("ITEM_BUNDLE", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateItemBundle({ commit }, params) {
    return new Promise((resolve, reject) => {
      repository
        .updateitembundle(params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("UPDATE_ITEM_BUNDLE", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  destroyItemBundle({ commit }, params) {
    return new Promise((resolve, reject) => {
      repository
        .destroyitembundle(params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("DESTROY_ITEM_BUNDLE", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllItemTypes({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.all_item_types.length > 0) {
        resolve(state.all_item_types);
        return;
      }
      repository
        .getallitemtypes()
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("ALL_ITEM_TYPES", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  storeItemTypes({ commit }, params) {
    return new Promise((resolve, reject) => {
      repository
        .storeitemtypes(params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("STORE_ITEM_TYPES", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  showItemTypes({ commit }, params) {
    return new Promise((resolve, reject) => {
      repository
        .showitemtypes(params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("SHOW_ITEM_TYPES", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateItemTypes({ commit }, params) {
    return new Promise((resolve, reject) => {
      repository
        .updateitemtypes(params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("UPDATE_ITEM_TYPES", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  destroyItemType({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .destroyitemtype(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("DESTROY_ITEM_TYPE", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllItemCategories({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.all_item_categories.length > 0) {
        resolve(state.all_item_categories);
        return;
      }
      repository
        .getallitemcategories()
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("ALL_ITEM_CATEGORIES", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  storeItemCategories({ commit }, params) {
    return new Promise((resolve, reject) => {
      repository
        .storeitemcategories(params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("STORE_ITEM_CATEGORIES", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  showItemCategories({ commit }, params) {
    return new Promise((resolve, reject) => {
      repository
        .showitemcategories(params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("SHOW_ITEM_CATEGORIES", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateItemCategories({ commit }, params) {
    return new Promise((resolve, reject) => {
      repository
        .updateitemcategories(params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("UPDATE_ITEM_CATEGORIES", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  destroyItemCategories({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .destroyitemcategories(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("DESTROY_ITEM_CATEGORIES", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllItemUom({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.all_item_uom.length > 0) {
        resolve(state.all_item_uom);
        return;
      }
      repository
        .getallitemuom()
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("ALL_ITEM_UOM", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  storeItemUom({ commit }, params) {
    return new Promise((resolve, reject) => {
      repository
        .storeitemuom(params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("STORE_ITEM_UOM", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  showItemUom({ commit }, params) {
    return new Promise((resolve, reject) => {
      repository
        .showitemuom(params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("SHOW_ITEM_UOM", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateItemUom({ commit }, params) {
    return new Promise((resolve, reject) => {
      repository
        .updateitemuom(params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("UPDATE_ITEM_UOM", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  destroyItemUom({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .destroyitemuom(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("DESTROY_ITEM_UOM", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllItemBrand({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.all_item_brand.length > 0) {
        resolve(state.all_item_brand);
        return;
      }
      repository
        .getallitembrand()
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("ALL_ITEM_BRAND", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  storeItemBrand({ commit }, params) {
    return new Promise((resolve, reject) => {
      repository
        .storeitembrand(params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("STORE_ITEM_BRAND", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  showItemBrand({ commit }, params) {
    return new Promise((resolve, reject) => {
      repository
        .showitembrand(params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("SHOW_ITEM_BRAND", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateItemBrand({ commit }, params) {
    return new Promise((resolve, reject) => {
      repository
        .updateitembrand(params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("UPDATE_ITEM_BRAND", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  destroyItemBrand({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .destroyitembrand(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("DESTROY_ITEM_BRAND", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllItemSizes({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.all_item_sizes.length > 0) {
        resolve(state.all_item_sizes);
        return;
      }
      repository
        .getallitemsizes()
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("ALL_ITEM_SIZES", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  storeItemSizes({ commit }, params) {
    return new Promise((resolve, reject) => {
      repository
        .storeitemsizes(params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("STORE_ITEM_SIZES", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  showItemSizes({ commit }, params) {
    return new Promise((resolve, reject) => {
      repository
        .showitemsizes(params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("SHOW_ITEM_SIZES", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateItemSizes({ commit }, params) {
    return new Promise((resolve, reject) => {
      repository
        .updateitemsizes(params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("UPDATE_ITEM_SIZES", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  destroyItemSizes({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .destroyitemsizes(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("DESTROY_ITEM_SIZES", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getItemSubstitution({ commit }, params) {
    return new Promise((resolve, reject) => {
      repository
        .getitemsubstitutions(params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("ITEM_SUBSTITUTION", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  exportItemMasterToExcel({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .exportitemmastertoexcel(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("EXP_ITEM_MASTER", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getItemTemplate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .getitemtemplate(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("ITEM_TEMPLATE", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  itemTemplateSelection({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .itemtemplateselection(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("ITEM_TEMPLATE_SELECTION", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  itemTemplateCanEdit({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .itemtemplatecanedit(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  itemTemplateUpdate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .itemtemplateupdate(payload.id, payload.params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postItemTemplate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .postitemtemplate(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  destroyItemTemplate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .destroyitemtemplate(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  itemTemplateDetails({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .itemtemplatedetails(payload.id, payload.params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("ITEM_TEMPLATE_DETAILS", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  itemTemplateClearDetails({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .itemtemplatecleardetails(payload.id, payload.params)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getBundledItems({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .getbundleditems(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  confirmOverrideAmounts({ commit }, payload) {
    let params = {
      departments_allowed: payload.departments_allowed,
      override_username: payload.override_username,
      override_user_password: payload.override_user_password,
    };
    return new Promise((resolve, reject) => {
      repository
        .confirmoverrideamounts(params)
        .then((response) => {
          resolve(response);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  getItemEditInfoshared({ commit }, payload) {
    let params = {
      promo_id: payload.promo_id,
      customer_id: payload.customer_id,
      model_id: payload.model_id,
    };
    return new Promise((resolve, reject) => {
      repository
        .getItemEditInfoshared(params)
        .then((response) => {
          resolve(response);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  getitemsmodelid({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .getitemsmodelid(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  getNewerModel({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .getnewermodel(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  getItemId({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .getitemid(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  getSubstitutionItemModel({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .getSubstitutionItemModel(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  itemsPost({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .itemsPost(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getPartsCompatibility({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .getpartscompatibility(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
            commit("PARTS_COMPATIBILITY", response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  checkItemSpareParts({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .checkitemspareparts(payload)
        .then((response) => {
          if (response.status == 200) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getItemsTempList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .itemsTempList(payload)
        .then((response) => {
          commit("ITEM_TEMP_LIST", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  getItemChanges({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .getItemChanges(payload)
        .then((response) => {
          commit("ITEM_CHANGES", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  approveItemTemp({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .approveItemTemp(payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  rejectItemTemp({ commit }, payload) {
    return new Promise((resolve, reject) => {
      repository
        .rejectItemTemp(payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  fetchCanBypassItemApproval({ commit }) {
    return new Promise((resolve, reject) => {
      repository
        .canBypassItemApproval()
        .then((response) => {
          commit("CAN_BYPASS_ITEM_APPROVAL", response.data.can_bypass);
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  fetchCanApproveItemChanges({ commit }) {
    return new Promise((resolve, reject) => {
      repository
        .canApproveItemChanges()
        .then((response) => {
          commit("CAN_APPROVE_ITEM_CHANGES", response.data.can_approve);
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  getItemApprovalSettings({ commit }) {
    return new Promise((resolve, reject) => {
      repository
        .getItemApprovalSettings()
        .then((response) => {
          commit("ITEM_APPROVAL_SETTINGS", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  storeItemApprovalBypass({ commit }, payload) {
    return repository.storeItemApprovalBypass(payload);
  },
  updateItemApprovalBypass({ commit }, { id, payload }) {
    return repository.updateItemApprovalBypass(id, payload);
  },
  destroyItemApprovalBypass({ commit }, id) {
    return repository.destroyItemApprovalBypass(id);
  },
  storeItemApprovalApprover({ commit }, payload) {
    return repository.storeItemApprovalApprover(payload);
  },
  updateItemApprovalApprover({ commit }, { id, payload }) {
    return repository.updateItemApprovalApprover(id, payload);
  },
  destroyItemApprovalApprover({ commit }, id) {
    return repository.destroyItemApprovalApprover(id);
  },
};
